import React from 'react';
import Modal from '../../shared/modal';
import TeamTable from './TeamTable';
import ReactDOM from 'react-dom';

interface ITeamsModal {
    openModal: boolean;
    status?: any;
    handleCloseModal: () => void;
    SuccessfullyDeleted: () => void;
    onlyOne?: boolean;
}

const TeamsModal = ({
    openModal,
    status,
    handleCloseModal,
    SuccessfullyDeleted,
    onlyOne = false,
}: ITeamsModal) => {
    const onCloseModal = () => {
        handleCloseModal();
    };

    return ReactDOM.createPortal(
        <Modal
            open={openModal}
            onClose={onCloseModal}
            contentContainerStyle={
                '!rounded-xl min-w-[95%] md:min-w-[70%] lg:min-w-[60%]'
            }>
            <div
                className={
                    'p-2 min-w-[95%] md:min-w-[70%] lg:min-w-[60%] min-h-[500px] '
                }>
                <p className="mb-2 font-semibold text-sm dark:text-primary-dark">
                    Team{' '}
                </p>
                <p className="mb-4 text-sm dark:text-primary-dark">
                    Select role you want to assign to this user.
                </p>
                <div>
                    <TeamTable
                        status={status}
                        onCloseModal={onCloseModal}
                        SuccessfullyDeleted={SuccessfullyDeleted}
                        onlyOne={onlyOne}
                    />
                </div>
            </div>
        </Modal>,
        document.body
    );
};
export default TeamsModal;
